import React, {useState} from "react";
import ActivityIndicatorsTable from "./ActivityIndicatorsTable/ActivityIndicatorsTable";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../../utils/utils"

function ActivityIndicatorsCard(props) {

    const [expanded, setExpanded] = useState(false);
    const [firstTime, setFirstTime] = useState(true);


    const {activity_indicators} = props
    let initialExpand = activity_indicators.flag === "positive"? false : true
    if (initialExpand !== expanded && firstTime===true){
        setExpanded(initialExpand);
    }
    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    Indícios de Atividade
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(activity_indicators.flag)}
                </div>
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>
            </div>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    <ActivityIndicatorsTable activity_indicators={activity_indicators}/>
                </div>
            </Collapse>
        </div>
        );
}


export default ActivityIndicatorsCard
